import { BreadcrumComponent } from '../breadcrum/breadcrum.component';
import {
  AfterViewInit,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { AddressComponent } from '../address/address.component';
import { GstComponent } from '../gst/gst.component';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import {
  Subject,
  Subscription,
  debounceTime,
  distinctUntilChanged,
  filter,
} from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api.service';
import { CookieService } from '../../shared/services/cookie.service';
import { secureStorage } from '../../shared/services/secure-storage.service';
import { StorageService } from '../../shared/services/storage.service';
import { LoaderService } from '../../shared/services/loader.service';
import { PaymentService } from '../../shared/services/payment.service';
import { AuthService } from '../../shared/services/auth.service';
import { BuyerVerificationService } from '../../shared/services/buyer-verification.service';
import { NotificationService } from '../../shared/services/notification.service';
import { CouponComponent } from '../coupon/coupon.component';
import {
  appendOnlinePaymentFields,
  assignPaymentFlow,
  extractPriceBreakup,
  getOnlinePaymentFields,
  toAmountNumber,
} from '../../shared/constants/payment-flow';
import {
  canAddGstDetails as canAddGstDetailsUtil,
  canPlaceOrder as canPlaceOrderUtil,
} from '../../shared/utils/gst-eligibility';

@Component({
  selector: 'app-booking-page',
  standalone: true,
  imports: [
    AddressComponent,
    GstComponent,
    CouponComponent,
    BreadcrumComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './booking-page.component.html',
  styleUrl: './booking-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingPageComponent implements AfterViewInit, OnInit, OnDestroy {
  bookingBreadcrumbs: any[] = [{ label: 'Cart', url: '/cart' }, { label: 'Booking', url: '/booking-page' }];
  // Allow only digits and prevent leading space for PIN code
  preventNonDigitOrLeadingSpace(event: KeyboardEvent, input: any) {
    const key = event.key;
    // Block space as first character
    if (key === ' ' && (!input.value || input.selectionStart === 0)) {
      event.preventDefault();
      return;
    }
    // Block non-digit characters
    if (
      !/^[0-9]$/.test(key) &&
      key !== 'Backspace' &&
      key !== 'Tab' &&
      key !== 'ArrowLeft' &&
      key !== 'ArrowRight'
    ) {
      event.preventDefault();
    }
  }
  // Prevent space as first character for address fields
  preventLeadingSpace(event: KeyboardEvent, input: any) {
    if (event.key === ' ' && (!input.value || input.selectionStart === 0)) {
      event.preventDefault();
    }
  }
  // Prevent number and space input for name fields
  preventNumberAndSpaceInput(event: KeyboardEvent) {
    const key = event.key;

    // Allow navigation keys
    if (
      [
        'Backspace',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Delete',
      ].includes(key)
    ) {
      return;
    }

    // Allow only alphabets
    if (!/^[a-zA-Z]$/.test(key)) {
      event.preventDefault();
    }
  }

  prevenSpaceInput(event: KeyboardEvent) {
    const key = event.key;

    // Allow navigation keys
    if (
      [
        'Backspace',
        'Tab',
        'Enter',
        'ArrowLeft',
        'ArrowRight',
        'ArrowUp',
        'ArrowDown',
        'Delete',
      ].includes(key)
    ) {
      return;
    }

    const regex = /^[a-zA-Z0-9@._%+-]$/;

    if (!regex.test(key)) {
      event.preventDefault();
    }
  }
  @ViewChild('firstNameInput') firstNameInput!: ElementRef;
  @ViewChild('emailInput') emailInput!: NgModel;

  // Form properties
  addressForm!: FormGroup;
  type: string = 'shipping'; // Default type
  autoFilledCity: boolean = false;
  autoFilledState: boolean = false;
  editingAddress: boolean = false;

  // Dropdown data
  states: any[] = [];
  cities: any[] = [];
  selectedState: string = '';
  selectedCity: string = '';

  // Component properties
  billingType: any;
  deliveryform: boolean = true;
  showPersonalForm: boolean = false;
  addBillingInfo: boolean = false;
  isStorePickup: boolean = false;
  showBillingDetails: boolean = false;
  showGSTINInvoice: boolean = false;
  showBillingPopup: boolean = false;
  isContinue: boolean = false;
  showGSTINPopup = false;
  gstinDetails: any = null;
  editingBillingData: any = null;
  showTaxBreakdown: boolean = false;
  addresses: any = [];
  sub: Subscription = new Subscription();
  routerSub: Subscription = new Subscription();
  products: any[] = [];
  parsedData: any;
  private previousUrl: string = '';

  // Dynamic product data
  selectedProduct: any = null;
  totalAmount: number = 0;
  subTotal: number = 0;
  taxesAndCharges: number = 0;

  // Missing properties for payment functionality
  productDetailData: any = null;
  selectedDeliveryOption: string = 'home';
  quantity: number = 1;
  orderDetail: any = null;
  oreder_number: string = '';
  ccavenue: any = null;

  // Delivery Details

  // Store/Seller Details
  sellerDetails = {
    name: '',
    address: '',
    gstin: '', // Will be used when GSTIN invoice is added
  };

  // Form fields
  firstName: string = '';
  lastName: string = '';
  email: string = '';

  // User type selection
  selectedUserType: string = '';
  userTypes: string[] = [
    'Individual',
    'Fleet owner',
    'Garage Owner',
    'Mechanic',
    'Retailer',
    'End Product Manufacturer',
    'Scrap Recycler',
    'Scrap Trader',
    'Refurbisher',
  ];
  userData: any;

  get canAddGstDetails(): boolean {
    return canAddGstDetailsUtil(this.userData);
  }

  // Coupon-related properties
  availableCoupons: any[] = [];
  selectedCoupon: any = null;
  showCouponSection: boolean = false;
  payFullAmount: boolean = false;
  showFullPaymentConfirm: boolean = false;

  // Current location (for mobile "Current Location" action)
  currentLatitude: number | null = null;
  currentLongitude: number | null = null;
  currentLocationLoading: boolean = false;
  currentLocationError: string | null = null;
  isLocationLoading: boolean = false;
  locationError: boolean = false;
  userLocation: any = null;

  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
    private storageService: StorageService,
    private ssrcookieService: CookieService,
    private localstorage: secureStorage,
    private loaderService: LoaderService,
    public paymentService: PaymentService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private ngZone: NgZone,
    private authService: AuthService,
    private notificationService: NotificationService,
    private buyerVerificationService: BuyerVerificationService,
  ) {
    this.formBuilder = this.fb;
  }

  // Get user's current geolocation (used in mobile Location section)
  getCurrentLocation(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!('geolocation' in navigator)) {
      console.error('Geolocation is not supported by this browser.');
      this.currentLocationError =
        'Geolocation is not supported by this browser.';
      return;
    }

    this.currentLocationLoading = true;
    this.currentLocationError = null;

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.ngZone.run(() => {
          this.currentLatitude = position.coords.latitude;
          this.currentLongitude = position.coords.longitude;
          this.currentLocationLoading = false;

          // TODO: Use latitude/longitude to auto-fill address fields via a reverse-geocoding API if available.
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.currentLocationLoading = false;
          switch (error.code) {
            case error.PERMISSION_DENIED:
              this.currentLocationError = 'Location permission was denied.';
              break;
            case error.POSITION_UNAVAILABLE:
              this.currentLocationError =
                'Location information is unavailable.';
              break;
            case error.TIMEOUT:
              this.currentLocationError = 'Location request timed out.';
              break;
            default:
              this.currentLocationError =
                'An unknown error occurred while fetching location.';
          }
          console.error('Geolocation error:', error);
        });
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      },
    );
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        const userDataString = localStorage.getItem('userData1');
        if (userDataString) {
          if (userDataString.startsWith('U2FsdGVkX1')) {
            this.userData = {};
          } else {
            this.userData = JSON.parse(userDataString);
          }
        } else {
          this.userData = {};
        }
      } catch (error) {
        console.error('Error parsing userData1 from localStorage:', error);
        this.userData = {};
        // this.notificationService.error(
        //   'Failed to load user data. Please log in again.',
        // );
      }
      this.initializeForm();

      // Initialize personal details form fields with user data if available
      this.firstName = this.userData?.first_name || '';
      this.lastName = this.userData?.last_name || '';
      this.email = this.userData?.email_id || '';
      this.selectedUserType = this.userData?.user_type || '';

      // Only show personal form if user doesn't have complete personal details
      // if (this.userData?.first_name && this.userData?.last_name) {
      //   this.showPersonalForm = false;
      // } else {
      //   this.showPersonalForm = true; // Show form if personal details are missing
      // }
      this.getAddressData();
      this.getProductList(); // Load existing addresses
      // this.loadStates(); // Load states dropdown

      // Subscribe to route changes
      this.setupRouteChangeDetection();
    }
  }

  setupRouteChangeDetection(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Initialize previousUrl with current route
    this.previousUrl = this.router.url;

    // Subscribe to router events to detect route changes
    this.routerSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Check if we're navigating away from booking-page
        const targetUrl = event.url;
        const wasOnBookingPage = this.previousUrl.includes('/booking-page');
        const isLeavingBookingPage =
          wasOnBookingPage && !targetUrl.includes('/booking-page');

        if (isLeavingBookingPage) {
          // User is leaving booking-page, check if userData has first_name
          try {
            let currentUserData = {};
            const userDataString = localStorage.getItem('userData1');
            if (userDataString && !userDataString.startsWith('U2FsdGVkX1')) {
              currentUserData = JSON.parse(userDataString);
            }

            if (!(currentUserData as any)?.first_name) {
              // User doesn't have first_name, logout first
              this.handleLogout();

              // The navigation will continue to the new route after logout
              // We don't need to navigate again as the router is already navigating
            }
          } catch (error) {
            console.error('Error checking user data:', error);
          }
        }
      } else if (event instanceof NavigationEnd) {
        // Update previousUrl after navigation completes
        this.previousUrl = event.urlAfterRedirects || event.url;
      }
    });
  }

  handleLogout(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    // Clear user data
    localStorage.removeItem('userData1');
    localStorage.removeItem('userData');
    localStorage.removeItem('useractive');
    localStorage.removeItem('userCode');
    localStorage.removeItem('eol_user_code');
    localStorage.removeItem('eol_ref_token');
    localStorage.removeItem('eol_access_token');
    localStorage.removeItem('registrationPhoneNumber');
    localStorage.removeItem('registrationOtp');

    // Clear cookies
    try {
      this.ssrcookieService.removeItem('eol_user');
    } catch (error) {
      console.error('Error removing cookie:', error);
    }

    // The navigation will continue to the new route automatically
    // No need to reload - the route change will handle the state update
  }

  initializeForm(): void {
    // Get shipping data from userData
    const shippingData = this.userData?.shipping_address || {};

    this.addressForm = this.fb.group({
      flatHouseNo: [
        shippingData?.address_1 || '',
        [Validators.required, Validators.minLength(2)],
      ],
      locality: [
        shippingData?.land_mark || '',
        [Validators.required, Validators.minLength(2)],
      ],
      pin: [
        shippingData?.pincode || '',
        [Validators.required, Validators.pattern(/^[0-9]{6}$/)],
      ],
      state: [
        shippingData.state || '',
        [Validators.required, Validators.minLength(2)],
      ],
      city: [
        shippingData?.city || '',
        [Validators.required, Validators.minLength(2)],
      ],
      ...(this.type === 'shipping' && {
        saveAs: [shippingData?.saveAs || shippingData?.address_type || 'home'],
        receiverName: [
          shippingData?.receiverName || shippingData?.receiver_name || '',
          [Validators.minLength(2)],
        ],
        receiverPhone: [
          shippingData?.receiverPhone || shippingData?.receiver_phone_no || '',
          [Validators.pattern(/^[0-9]{10}$/)],
        ],
      }),
      ...(this.type === 'billing' && {
        companyName: [shippingData?.company_name || ''],
      }),
    });

    // Subscribe to pincode changes
    this.sub.add(
      this.addressForm
        .get('pin')
        ?.valueChanges.pipe(
          debounceTime(500), // Wait 500ms after user stops typing
          distinctUntilChanged(), // Only emit if value has changed
        )
        .subscribe((pincode: string) => {
          this.onPincodeChange(pincode);
        }),
    );

    // Initialize selected values
    this.selectedState = shippingData.state || '';
    this.selectedCity = shippingData?.city || '';

    // Subscribe to city and state changes to track manual edits
    this.sub.add(
      this.addressForm.get('city')?.valueChanges.subscribe((value: string) => {
        if (
          this.autoFilledCity &&
          value !== this.addressForm.get('city')?.value
        ) {
          this.autoFilledCity = false;
        }
      }),
    );

    this.sub.add(
      this.addressForm.get('state')?.valueChanges.subscribe((value: string) => {
        if (
          this.autoFilledState &&
          value !== this.addressForm.get('state')?.value
        ) {
          this.autoFilledState = false;
        }
      }),
    );
  }

  // Method to handle pincode changes and auto-fill city/state
  onPincodeChange(pincode: string): void {
    if (pincode && pincode.length === 6) {
      // Call API to get city and state based on pincode
      const payload = {
        dropdown_type: 'get_data_by_pincode',
        search_pincode: pincode,
      };

      this.apiService
        .dataBypincode(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            if (res.success && res.data) {
              const cityName = res.data.data_by_pincode[0].city_name;
              const stateName = res.data.data_by_pincode[0].state_name;

              this.selectedState = stateName;
              this.selectedCity = cityName;
              this.autoFilledCity = true;
              this.autoFilledState = true;

              this.states = [stateName];
              this.cities = [cityName];

              this.addressForm.patchValue({
                city: cityName,
                state: stateName,
              });
              // this.notificationService.success('City and state auto-filled based on pincode');
              this.cdr.markForCheck();
            } else {
              // this.notificationService.error(
              //   'Invalid pincode. Please enter a valid 6-digit pincode.',
              // );
            }
          },
          error: (err: any) => {
            console.error('Error fetching pincode details:', err);
            // this.notificationService.error(
            //   err?.error?.data?.msg ||
            //     'Failed to fetch location details for this pincode',
            // );
          },
        });
    } else {
      // Clear state and city fields when pincode is removed or invalid
      this.selectedState = '';
      this.selectedCity = '';
      this.autoFilledCity = false;
      this.autoFilledState = false;
      this.states = [];
      this.cities = [];

      this.addressForm.patchValue({
        city: '',
        state: '',
      });
    }
  }

  getProductList() {
    this.loaderService.show();
    const productData = localStorage.getItem('booking_page_product_data');

    this.parsedData = productData ? JSON.parse(productData) : [];
    try {
      let data = {
        limit: 12,
        offset: 0,
        // "get_plp_data": true,
        part_number_list: this.parsedData.part_number
          ? [this.parsedData.part_number]
          : [],
      };

      this.apiService
        .getProductlistData(data)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (value) => {
            this.loaderService.hide();
            if (value.success) {
              this.products = value.data.part_list;

              // Set the first product as selected product for display
              if (this.products && this.products.length > 0) {
                this.selectedProduct = this.products[0];

                this.getPricebreakup();

                // Fetch available coupons
                this.fetchCouponsData();

                this.updateSellerDetails();
                // this.notificationService.success('Product details loaded successfully');
              } else {
                // this.notificationService.error('No products found');
              }

              // Process product images
              this.products.forEach((product) => {
                if (Array.isArray(product.part_image_path)) {
                  product.images = product.part_image_path;
                } else if (product.part_image_path) {
                  product.images = [product.part_image_path];
                } else {
                  product.images = [];
                }
                product.currentImageIndex = 0;
              });
              this.cdr.markForCheck();
            } else {
              this.products = [];
              // this.notificationService.error('Failed to load product details');
              this.cdr.markForCheck();
            }
          },
          error: (err) => {
            this.loaderService.hide();
            console.error('Error loading products:', err);

            // Handle specific error codes
            if (err.status === 412) {
              // this.notificationService.error(
              //   'Server temporarily unavailable. Please try again.',
              // );
            } else if (err.status === 401) {
              // this.notificationService.error('Please log in to continue');
            } else if (err.status === 403) {
              // this.notificationService.error(
              //   'Access denied. Please contact support.',
              // );
            } else {
              // this.notificationService.error(
              //   err?.error?.data?.msg || 'Failed to load products',
              // );
            }
            this.cdr.markForCheck();
          },
        });
    } catch (error) {
      this.loaderService.hide();
      console.error('Error in getProductList:', error);
      // this.products = [];
    }
  }

  applyPriceBreakup(res: any): boolean {
    const breakup = extractPriceBreakup(res);
    if (!breakup || !this.selectedProduct) {
      return false;
    }
    this.selectedProduct = {
      ...this.selectedProduct,
      price_breakup: { ...breakup },
    };
    this.cdr.detectChanges();
    return true;
  }

  getBookingPercentage(): string {
    if (this.selectedProduct?.booking_percent_rule) {
      return this.selectedProduct.booking_percent_rule.toString();
    }
    if (this.selectedProduct?.price_breakup?.booking_percent_rule) {
      return this.selectedProduct.price_breakup.booking_percent_rule.toString();
    }
    const base = this.getBasePrice();
    const booking = Number(this.selectedProduct?.price_breakup?.scrap_booking_amount || 0);
    if (booking > 0 && base > 0) {
      const pct = Math.round((booking / base) * 100);
      if (pct > 0 && pct <= 100) return pct.toString();
    }
    return '';
  }

  getBasePrice(): number {
    const orderTotal = Number(
      this.selectedProduct?.price_breakup?.order_total ||
        this.selectedProduct?.price_breakup?.orderTotal ||
        0,
    );
    if (orderTotal > 0) {
      return orderTotal;
    }
    const breakupBase = Number(this.selectedProduct?.price_breakup?.base_price || 0);
    if (breakupBase > 0) {
      return breakupBase;
    }
    const productBase = Number(this.selectedProduct?.base_price || 0);
    if (productBase > 0) {
      return productBase;
    }
    const qty = Number(this.parsedData?.quantity) || 1;
    if (this.selectedProduct?.part_type === 'Scrap Part') {
      const rate = this.selectedProduct?.discounted_taxable
        ? Number(this.selectedProduct.discounted_taxable)
        : (Number(this.selectedProduct?.taxable_amount) || Number(this.selectedProduct?.price_s) || 0);
      if (rate > 0) {
        return rate * qty;
      }
    }
    const price = Number(this.selectedProduct?.discounted_price || this.selectedProduct?.price_s || 0);
    return price * qty;
  }

  getBalanceAmount(): number {
    const remaining = Number(
      this.selectedProduct?.price_breakup?.remaining_booking_amount ||
        this.selectedProduct?.price_breakup?.remainingBookingAmount ||
        0,
    );
    if (remaining > 0) {
      return remaining;
    }
    const base = this.getBasePrice();
    const booking = toAmountNumber(
      this.selectedProduct?.price_breakup?.scrap_booking_amount ||
        this.selectedProduct?.scrap_booking_amount ||
        this.selectedProduct?.booking_amount ||
        0,
    );
    return Math.max(base - booking, 0);
  }

  getPricebreakup() {
    const payload: Record<string, unknown> = {
      coupon_code: this.selectedCoupon?.coupon_code || '',
      offer_id: this.selectedCoupon?.row_id || '',
      parts: [
        {
          part_number: this.selectedProduct?.part_number,
          part_type: this.selectedProduct?.part_type,
          total_quantity: this.parsedData?.quantity
            ? this.parsedData.quantity
            : 1,
          booking_percent_rule:
            this.selectedProduct?.part_type === 'Scrap Part'
              ? this.selectedProduct?.booking_percent_rule
              : '',
        },
      ],
    };
    assignPaymentFlow(payload, this.getOnlinePaymentPayload().payment_flow);

    this.loaderService.show();
    this.apiService
      .getBuyNowPriceBreakup(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.loaderService.hide();
          if (res.success && this.applyPriceBreakup(res)) {
            return;
          }
          // this.notificationService.error(
          //   res?.data?.msg || 'Failed to calculate price',
          // );
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.loaderService.hide();
          console.error('Error getting price breakup:', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg || 'Failed to get price breakup',
          // );
          this.cdr.detectChanges();
        },
      });
  }

  ngAfterViewInit() {
    // Set focus on first name input after view initialization
    if (this.firstNameInput) {
      setTimeout(() => {
        this.firstNameInput.nativeElement?.focus();
      });
    }
  }

  toggleDeliveryMethod(isStorePickup: boolean) {
    this.isStorePickup = isStorePickup;
    this.deliveryform = !isStorePickup;
    // Reset billing options when switching delivery method
    if (this.isStorePickup) {
      this.showBillingDetails = true;
      // this.showGSTINInvoice = true;
    }
  }

  toggleBillingDetails(type?: any) {
    this.billingType = type;
    this.showBillingDetails = true;
    // this.showBillingDetails = !this.showBillingDetails;
    this.showBillingPopup = true;

    // Always start with empty form when clicking "Add different Billing details" radio button
    // Only pre-fill data when using "Change" button on existing billing details
    this.editingBillingData = null;

    if (this.showBillingDetails) {
      this.showGSTINInvoice = false;
      this.showGSTINPopup = false;
    }
  }

  editBillingDetails(type?: any) {
    this.billingType = type;
    this.showBillingDetails = true;
    this.showBillingPopup = true;

    // Pre-fill form with existing billing data when editing
    if (type === 'billing' && this.userData?.billing_address?.address_1) {
      this.editingBillingData = this.userData.billing_address;
    } else {
      this.editingBillingData = null;
    }

    if (this.showBillingDetails) {
      this.showGSTINInvoice = false;
      this.showGSTINPopup = false;
    }
  }

  toggleGSTINInvoice() {
    if (!this.canAddGstDetails) {
      return;
    }
    this.showGSTINInvoice = !this.showGSTINInvoice;
    this.showGSTINPopup = true;
    this.showBillingDetails = true;
    if (this.showGSTINInvoice) {
      this.showBillingPopup = false;
    }
  }

  toggleTaxBreakdown() {
    this.showTaxBreakdown = !this.showTaxBreakdown;
  }

  couponmodel() {
    this.fetchCouponsData();
    this.showCouponSection = true;
  }

  onCloseCouponPopup() {
    this.showCouponSection = false;
  }

  fetchCouponsData() {
    const userData = JSON.parse(localStorage.getItem('userData1') || '{}');

    // Calculate total quantity based on selected product
    let totalQuantity = 0;
    if (this.selectedProduct) {
      const item = this.selectedProduct;
      if (item?.part_type === 'Scrap Part') {
        if (item?.selectedUnit === 'kg' || item?.selectedUnit === 'Kg') {
          totalQuantity = item?.customKgQuantity
            ? parseFloat(item.customKgQuantity)
            : 0;
        } else if (
          item?.selectedUnit === 'liter' ||
          item?.selectedUnit === 'Litr'
        ) {
          totalQuantity = item?.customLiterQuantity
            ? parseFloat(item.customLiterQuantity)
            : 0;
        } else {
          const tonQty =
            item?.quantity === 'custom'
              ? item?.customTonQuantity
                ? parseFloat(item.customTonQuantity)
                : 0
              : item?.total_quantity || item?.quantity || 0;
          totalQuantity = tonQty * 1000;
        }
      } else {
        totalQuantity = item?.total_quantity || item?.quantity || 1;
      }
    }

    let allItems: any[] = [];
    if (this.selectedProduct) {
      allItems.push({
        part_number:
          this.selectedProduct?.part_number ||
          this.selectedProduct?.inventory_id,
        part_type: this.selectedProduct?.part_type,
        total_quantity: this.selectedProduct.total_quantity || totalQuantity,
        discounted_taxable: this.selectedProduct.discounted_taxable,
        final_total: this.selectedProduct.final_total,
        make: this.selectedProduct.make,
        model: this.selectedProduct.model,
        negotiated_price: this.selectedProduct.negotiated_price,
        scrap_category: this.selectedProduct.scrap_category,
        seller_code: this.selectedProduct.seller_code_s,
        tax_s: this.selectedProduct.tax_s,
      });
    }

    const payload = {
      items: allItems,
    };

    this.loaderService.show();
    this.apiService
      .getBuyerBestOffer(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.success && response.data) {
            // Transform the data to match the expected format
            this.availableCoupons = response.data.map((coupon: any) => ({
              ...coupon,
              savings: coupon.discount_amount,
              isActive: true,
            }));
            if (this.availableCoupons.length > 0) {
              // this.notificationService.success(`${this.availableCoupons.length} coupon(s) available`);
            } else {
              // this.notificationService.info('No coupons available for this order');
            }
          } else {
            // this.notificationService.info('No coupons available');
          }
          this.loaderService.hide();
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Error fetching coupons:', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg || 'Failed to load coupons',
          // );
          this.loaderService.hide();
          this.cdr.markForCheck();
        },
      });
  }

  onSaveCouponDetails(event: any) {
    this.selectedCoupon = event;
    this.showCouponSection = false;

    // Recalculate price with coupon
    this.getPriceBreakupWithCoupon();
  }

  getPriceBreakupWithCoupon() {
    if (!this.selectedProduct) {
      return;
    }

    let totalQuantity = 0;
    const item = this.selectedProduct;

    if (item?.part_type === 'Scrap Part') {
      if (item?.selectedUnit === 'kg' || item?.selectedUnit === 'Kg') {
        totalQuantity = item?.customKgQuantity
          ? parseFloat(item.customKgQuantity)
          : 0;
      } else if (
        item?.selectedUnit === 'liter' ||
        item?.selectedUnit === 'Litr'
      ) {
        totalQuantity = item?.customLiterQuantity
          ? parseFloat(item.customLiterQuantity)
          : 0;
      } else {
        const tonQty =
          item?.quantity === 'custom'
            ? item?.customTonQuantity
              ? parseFloat(item.customTonQuantity)
              : 0
            : item?.total_quantity || item?.quantity || 0;
        totalQuantity = tonQty * 1000;
      }
    } else {
      totalQuantity = item?.total_quantity || item?.quantity || 1;
    }

    const payload: Record<string, unknown> = {
      coupon_code: this.selectedCoupon?.coupon_code || '',
      offer_id: this.selectedCoupon?.row_id || '',
      parts: [
        {
          part_number: item?.part_number || item?.inventory_id,
          part_type: item?.part_type,
          total_quantity: totalQuantity,
        },
      ],
    };
    assignPaymentFlow(payload, this.getOnlinePaymentPayload().payment_flow);

    this.loaderService.show();
    this.apiService
      .getBuyNowPriceBreakup(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success && this.applyPriceBreakup(res)) {
            // this.notificationService.success('Coupon applied successfully');
          } else {
            // this.notificationService.error(
            //   res?.data?.msg || 'Failed to apply coupon',
            // );
          }
          this.loaderService.hide();
        },
        error: (err) => {
          console.error('Error getting price breakup with coupon:', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg || 'Failed to apply coupon',
          // );
          this.loaderService.hide();
          this.cdr.markForCheck();
        },
      });
  }

  copyToClipboard(text: string) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        () => {
          alert('Coupon code copied to clipboard!');
        },
        (err) => {
          console.error('Could not copy text: ', err);
        },
      );
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        alert('Coupon code copied to clipboard!');
      } catch (err) {
        console.error('Could not copy text: ', err);
      }
      document.body.removeChild(textArea);
    }
  }

  editDeliveryDetails(type?: any) {
    this.billingType = type;
    this.type = type; // Set the form type
    this.deliveryform = false;
    this.editingAddress = true;

    // Reinitialize form with new type and existing data
    setTimeout(() => {
      this.initializeForm();
      // If switching to billing and we have shipping data, copy relevant fields
      if (type === 'billing' && this.userData?.shippingData) {
        this.copyShippingToBilling();
      }
    });
  }

  // Method to copy shipping data to billing form
  copyShippingToBilling(): void {
    if (this.userData?.shippingData && this.addressForm) {
      const shippingData = this.userData.shippingData;
      this.addressForm.patchValue({
        flatHouseNo: shippingData.flatHouseNo || shippingData.address_1 || '',
        locality: shippingData.locality || shippingData.land_mark || '',
        pin: shippingData.pin || shippingData.pincode || '',
        state: shippingData.state || '',
        city: shippingData.city || '',
        companyName:
          shippingData.companyName || shippingData.company_name || '',
      });
    }
  }

  saveDeliveryDetails() {
    // Implement delivery details save logic
    this.deliveryform = true;
    if (this.addressForm.valid) {
      const formData = {
        ...this.addressForm.value,
        // Add any additional processing here
        timestamp: new Date().toISOString(),
      };

      let payload: any = {
        address_1: formData.flatHouseNo,
        address_2: '',
        address_3: '',
        state: formData.state,
        city: formData.city,
        land_mark: formData.locality,
        pincode: formData.pin,
        phone_no: this.userData?.phone_number,
        is_gstin_no: false,
        gstin_number: '',
        address_type: formData.saveAs || 'home',
        address_type_name:
          this.billingType === 'billing'
            ? 'Billing Address'
            : 'Permanent Address',
      };

      if (this.type !== 'billing' && this.editingAddress) {
        payload.address_id = this.userData?.shipping_address.id;

        // payload.address_type_name = 'Billing Address';
      }

      if (this.type === 'shipping') {
        payload.receiver_name = formData.receiverName;
        payload.receiver_phone_no = formData.receiverPhone;
        // payload.is_save_ship_default = true;
      }

      // else if(this.type === 'billing'){
      //   payload.is_save_bill_default = true;
      // }

      // Add type-specific fields
      if (this.billingType === 'shipping') {
        payload.receiver_name = formData.receiverName;
        payload.receiver_phone_no = formData.receiverPhone;
      } else if (this.billingType === 'billing') {
        payload.company_name = formData.companyName;
      }

      this.apiService
        .addAddress(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            // Save form data to userData.shippingData
            this.saveShippingDataToUserData(formData);

            this.addressForm.reset();
            this.notificationService.success('Address saved successfully');

            // Close delivery form and open personal details form after successfully saving delivery details
            this.deliveryform = true;

            // Immediately show personal form (will be updated after API call if user has details)
            this.showPersonalForm = true;
            this.cdr.markForCheck();

            // Update user data and then check if personal form should be shown
            this.apiService
              .getUserDetails({})
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (res) => {
                  // Update localStorage and cookies with latest data
                  localStorage.setItem('userData1', JSON.stringify(res?.data));
                  this.ssrcookieService.setItem(
                    'eol_user',
                    JSON.stringify(res?.data),
                  );
                  this.userData = res?.data;

                  // Notify AuthService to update header component
                  this.authService.setLoggedInState(true, res?.data);

                  // Show personal form if user doesn't have complete personal details
                  if (this.userData?.first_name && this.userData?.last_name) {
                    this.showPersonalForm = false;
                  } else {
                    this.showPersonalForm = true;
                  }

                  // Force change detection to update UI immediately
                  this.cdr.markForCheck();
                },
                error: (err) => {
                  console.error('Failed to fetch user details', err);
                    // this.notificationService.error(
                    //   err?.error?.data?.msg || 'Failed to fetch user details',
                    // );
                  // Fallback: show personal form if API fails
                  this.showPersonalForm = true;
                  this.cdr.markForCheck();
                },
              });
          },
          error: (err) => {
            console.error('Error adding address:', err);
            // this.notificationService.error(
            //   err?.error?.data?.msg ||
            //     'Failed to save address. Please try again.',
            // );
            this.cdr.markForCheck();
          },
        });
    } else {
      // Mark all fields as touched to show validation errors
      this.markFormGroupTouched(this.addressForm);
      // this.notificationService.error(
      //   'Please fill in all required fields correctly',
      // );
    }
  }

  // Method to save shipping data to userData
  saveShippingDataToUserData(formData: any): void {
    if (isPlatformBrowser(this.platformId)) {
      // Update userData with shipping data
      if (!this.userData) {
        this.userData = {};
      }

      this.userData.shipping_address = {
        flatHouseNo: formData.flatHouseNo,
        locality: formData.locality,
        pin: formData.pin,
        state: formData.state,
        city: formData.city,
        saveAs: formData.saveAs,
        receiverName: formData.receiverName,
        receiverPhone: formData.receiverPhone,
        companyName: formData.companyName,
        timestamp: new Date().toISOString(),
      };

      // Save updated userData back to localStorage
      localStorage.setItem('userData1', JSON.stringify(this.userData));

      // Notify AuthService to update header component
      this.authService.refreshAuthState();
    }
  }

  // Helper method to mark all form controls as touched
  markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.get(key);
      control?.markAsTouched();
    });
  }

  selectUserType(type: string) {
    this.selectedUserType = type;
  }

  isFormValid(): boolean {
    // Check required fields
    const requiredFieldsValid = !!(
      this.firstName &&
      this.lastName &&
      this.selectedUserType
    );

    // Check email validation if email is provided
    // If email has a value, it must be valid according to the template pattern
    let emailValid = true;
    if (this.email && this.email.trim()) {
      // Use the same pattern as the template: ^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

      // If NgModel is available, use its validation state (more reliable)
      if (this.emailInput && this.emailInput.control) {
        // Email is invalid if there's a pattern error
        emailValid = !this.emailInput.control.errors?.['pattern'];
      } else {
        // Fallback to regex validation if NgModel is not yet available
        emailValid = emailPattern.test(this.email);
      }
    }

    return requiredFieldsValid && emailValid;
  }

  private isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  paymentErrorMessage: string | null = null;

  private showPaymentError(message: string): void {
    this.paymentErrorMessage = message;
    this.notificationService.error(message);
    this.cdr.markForCheck();
  }

  private async ensureBuyerVerificationBeforePayment(): Promise<boolean> {
    const orderGate =
      await this.buyerVerificationService.ensureCanCreateOrder(this.userData);

    if (orderGate.allowed) {
      return true;
    }

    this.showPaymentError(orderGate.message);
    return false;
  }

  get canPlaceOrder(): boolean {
    return canPlaceOrderUtil(this.userData);
  }

  // Method to check if user is ready to make payment
  isReadyForPayment(): boolean {
    if (!this.canPlaceOrder) {
      return false;
    }
    if (this.isStorePickup) {
      // Store pickup: only name details required
      return !!(this.userData?.first_name && this.userData?.last_name);
    } else {
      // Delivery: name + address required
      return !!(
        this.userData?.shipping_address?.address_1 &&
        this.userData?.first_name &&
        this.userData?.last_name
      );
    }
  }

  editPersonalDetails() {
    this.showPersonalForm = true;
  }

  savePersonalDetails() {
    if (this.isFormValid()) {
      const payload = {
        action_type: 'update',
        first_name: this.firstName,
        last_name: this.lastName,
        user_type: this.selectedUserType,
        email: this.email,
      };

      this.apiService
        .getUserDetails(payload)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            // Update localStorage and cookies with latest data
            localStorage.setItem('userData1', JSON.stringify(res?.data));
            this.ssrcookieService.setItem(
              'eol_user',
              JSON.stringify(res?.data),
            );
            this.userData = res?.data;

            // Notify AuthService to update header component
            this.authService.setLoggedInState(true, res?.data);

            // this.notificationService.success('Personal details saved successfully');
            this.showPersonalForm = false;
            this.cdr.markForCheck();
          },
          error: (err) => {
            console.error('Failed to update user details', err);
            // this.notificationService.error(
            //   err?.error?.data?.msg || 'Failed to save personal details',
            // );
            this.cdr.markForCheck();
          },
        });
    } else {
      // this.notificationService.error(
      //   'Please fill in all required fields correctly',
      // );
    }
  }

  onCloseBillingDetails() {
    this.showBillingPopup = false;
    this.showBillingDetails = true;
    this.editingBillingData = null;
  }

  onCloseGSTINPopup() {
    this.showGSTINPopup = false;
    this.showBillingDetails = true;
    if (!this.gstinDetails) {
      this.showGSTINInvoice = false;
    }
  }

  onSaveGSTINDetails(details: any) {
    this.gstinDetails = details;
    this.showGSTINPopup = false;
    this.getUserDetails();
    this.getAddressData();
  }

  getAddressData() {
    const payload = {
      offset: 0,
      limit: 10,
    };

    this.loaderService.show();

    this.apiService
      .getAddressData(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          this.addresses = res.data;

          // If we have addresses and no shipping data in userData, populate with first address
          if (
            this.addresses &&
            this.addresses.length > 0 &&
            !this.userData?.shippingData
          ) {
            const firstAddress = this.addresses[0];
            this.updateFormWithShippingData(firstAddress);
          }

          this.loaderService.hide();
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.loaderService.hide();
          console.error('Error fetching address data:', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg || 'Failed to load addresses',
          // );
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  // Method to update form with shipping data
  updateFormWithShippingData(shippingData: any): void {
    if (this.addressForm && shippingData) {
      this.addressForm.patchValue({
        flatHouseNo: shippingData.address_1 || '',
        locality: shippingData.land_mark || '',
        pin: shippingData.pincode || '',
        state: shippingData.state || '',
        city: shippingData.city || '',
        ...(this.type === 'shipping' && {
          saveAs: shippingData.address_type || 'home',
          receiverName: shippingData.receiver_name || '',
          receiverPhone: shippingData.receiver_phone_no || '',
        }),
        ...(this.type === 'billing' && {
          companyName: shippingData.company_name || '',
        }),
      });
    }
  }

  getUserDetails(): void {
    const payload = {};
    this.loaderService.show();
    this.apiService
      .getUserDetails(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.loaderService.hide();
          // Update localStorage and cookies with latest data
          localStorage.setItem('userData1', JSON.stringify(res?.data));
          this.ssrcookieService.setItem('eol_user', JSON.stringify(res?.data));
          this.userData = res?.data;

          // Notify AuthService to update header component
          this.authService.setLoggedInState(true, res?.data);
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.loaderService.hide();
          console.error('Failed to fetch user details', err);
          // this.notificationService.error(
          //   err?.error?.data?.msg || 'Failed to fetch user details',
          // );
          this.cdr.markForCheck();
        },
      });
  }

  ngOnDestroy() {
    // Clean up all subscriptions
    this.destroy$.next();
    this.destroy$.complete();

    this.sub.unsubscribe();
    if (this.routerSub) {
      this.routerSub.unsubscribe();
    }
  }
  updateSellerDetails(): void {
    if (this.selectedProduct) {
      this.sellerDetails = {
        name:
          this.selectedProduct.seller_name ||
          this.selectedProduct.branch_name ||
          'Unknown Seller',
        address: `${this.selectedProduct.seller_address_1 || ''}, ${
          this.selectedProduct.seller_address_2 || ''
        }, ${this.selectedProduct.seller_address_3 || ''}`,
        gstin: '',
        // pincode: this.selectedProduct.seller_pincode || '',
      };
    }
  }

  hasBookingAmount(): boolean {
    return (
      toAmountNumber(
        this.selectedProduct?.price_breakup?.scrap_booking_amount ||
        this.selectedProduct?.scrap_booking_amount ||
        this.selectedProduct?.booking_amount
      ) > 0
    );
  }

  getOnlinePaymentPayload() {
    return getOnlinePaymentFields({
      payFullAmount: this.payFullAmount,
      bookingAmount: this.selectedProduct?.price_breakup?.scrap_booking_amount,
      totalAmount: this.selectedProduct?.price_breakup?.total_amount,
    });
  }

  getPayableAmount(): number {
    return this.getOnlinePaymentPayload().online_amount;
  }

  onPayFullAmountChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      input.checked = false;
      this.showFullPaymentConfirm = true;
      this.cdr.detectChanges();
      return;
    }
    this.payFullAmount = false;
    this.cdr.detectChanges();
    this.getPricebreakup();
  }

  confirmFullPayment(): void {
    this.payFullAmount = true;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
    this.getPricebreakup();
  }

  cancelFullPayment(): void {
    this.payFullAmount = false;
    this.showFullPaymentConfirm = false;
    this.cdr.detectChanges();
  }

  // Method to format currency
  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      // minimumFractionDigits: 0,
      // maximumFractionDigits: 0,
    }).format(amount);
  }

  async onMakePayment() {
    this.paymentErrorMessage = null;

    if (!this.userData) {
      this.showPaymentError('Please login to continue with payment');
      return;
    }
    if (!this.isStorePickup && !this.userData.shipping_address) {
      this.showPaymentError('Please add a delivery address');
      return;
    }

    const canProceed = await this.ensureBuyerVerificationBeforePayment();
    if (!canProceed) {
      return;
    }

    const cartItems = localStorage.getItem('cartbooking_page_product_data');
    const cartdata = cartItems ? JSON.parse(cartItems) : [];

    const cartParts = Object.values(cartdata).map((entry: any) => ({
      part_number: entry.item.inventory_id,
      delivery_type: entry.deliveryOption, // <-- use outer deliveryOption
      req_quantity: this.parsedData?.quantity ? this.parsedData.quantity : 1,
    }));

    // Add item to cart and proceed to payment
    // const part_number = this.selectedProduct?.part_number;

    const part_number = this.selectedProduct?.part_number;

    const parts = [
      {
        part_number: part_number,
        delivery_type: this.isStorePickup ? 'Store Pickup' : 'Home Delivery',
        req_quantity: this.parsedData?.quantity ? this.parsedData.quantity : 1,
        inventory_id: this.selectedProduct?.inventory_id,
      },
    ];
    const formData = new FormData();

    formData.append('is_buy_now', 'true'); // always string
    formData.append('coupon_code', this.selectedCoupon?.coupon_code || '');
    formData.append('offer_id', this.selectedCoupon?.row_id || '');
    formData.append('parts', JSON.stringify(parts));
    appendOnlinePaymentFields(formData, this.getOnlinePaymentPayload());
    // const payload = {
    //   payment_method: 'Online Payment',
    //   is_buy_now: true,
    //   coupon_code: this.selectedCoupon?.coupon_code || '',
    //   offer_id: this.selectedCoupon?.row_id || '',
    //   parts:  [
    //     {
    //       part_number: part_number,
    //       delivery_type: this.isStorePickup ? 'Store Pickup' : 'Home Delivery',
    //       req_quantity: this.parsedData?.quantity ? this.parsedData.quantity : 1,
    //       inventory_id:this.selectedProduct?.inventory_id,

    //       // (this.selectedProduct?.part_type === 'Scrap Part'
    //       //   ? this.selectedProduct?.unit === 'Kg'
    //       //     ? this.quantity
    //       //     : this.quantity * 1000
    //       //   : 1
    //       // ).toString(),
    //     },
    //   ],
    // };
    // localStorage.removeItem('createdOrderDetail');
    this.loaderService.show();
    this.apiService
      .buyNow(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success) {
            localStorage.removeItem('cartbooking_page_product_data');
            localStorage.removeItem('booking_page_product_data');
            this.orderDetail = res.data;
            localStorage.setItem(
              'createdOrderDetail',
              JSON.stringify(this.orderDetail),
            );
            this.oreder_number = this.orderDetail?.order_detail?.order_number;
            // this.notificationService.success('Order created successfully. Redirecting to payment...');
            this.initiatePayment();
          } else {
            // this.notificationService.error(
            //   res?.data?.msg || 'Failed to create order',
            // );
          }
          this.loaderService.hide();
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.loaderService.hide();
          // this.notificationService.error(
          //   err?.error?.data?.msg ||
          //     'Failed to create order. Please try again.',
          // );
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  initiatePayment() {
    if (!this.oreder_number) {
      console.error('Order number not available');
      // this.notificationService.error(
      //   'Order number not available. Please try again.',
      // );
      return;
    }

    // Create payment request payload
    const paymentPayload = {
      order_number: this.oreder_number,
      payment_flow: this.getOnlinePaymentPayload().payment_flow,
    };
    this.loaderService.show();
    this.paymentService
      .getEncryptedPaymentData(paymentPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response.success && response.data) {
            this.ccavenue = response?.data;
            let encRequest = response?.data;
            let ccavenuForm: FormGroup = this.formBuilder.group({
              encRequest: [encRequest],
              access_code: [this.ccavenue?.access_code],
            });
            this.notificationService.info('Redirecting to payment gateway...');
            this.payWithCcavenu(ccavenuForm);
            this.loaderService.hide();
          } else {
            this.loaderService.hide();
            this.notificationService.error(
              response?.data?.msg || 'Payment initiation failed',
            );
            console.error('Payment failed:', response.error);
          }
        },
        error: (error: any) => {
          this.loaderService.hide();
          console.error('Payment service error:', error);
          // this.notificationService.error(
          //   error?.error?.data?.msg ||
          //     'Payment service error. Please try again.',
          // );
        },
      });
  }

  payWithCcavenu(formGroup: FormGroup) {
    if (!this.ccavenue || !this.ccavenue.ccavenue_url) {
      console.error('CCavenue configuration not available');
      // this.notificationService.error('Payment gateway configuration error');
      return;
    }

    const myform = document.createElement('form');
    myform.method = 'POST';

    // Fix the action URL construction
    const baseUrl = this.ccavenue.ccavenue_url;
    const separator = baseUrl.includes('?') ? '&' : '?';
    myform.action = `${baseUrl}${separator}encRequest=${this.ccavenue.encRequest}&access_code=${this.ccavenue.access_code}`;

    let input: any;
    for (const [key, value] of Object.entries(formGroup.value)) {
      input = document.createElement('input');
      input.name = key;
      input.id = key;
      input.value = value;
      myform.appendChild(input);
    }

    myform.style.display = 'none';
    document.body.appendChild(myform);
    myform.submit();
  }

  openPersonal() {
    this.addBillingInfo = true;
    this.showPersonalForm = true;
    this.isContinue = true;
  }

  onSaveAddressDetails(event: any) {
    this.getUserDetails();
    this.getAddressData();
    this.showPersonalForm = true;
    // this.cdref.detectChanges();
  }

  getUserLocation(): void {
    if (isPlatformBrowser(this.platformId) && 'geolocation' in navigator) {
      this.isLocationLoading = true;
      this.locationError = false;

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          this.getLocationDetails(latitude, longitude);

          this.cdr.detectChanges();
        },
        (error) => {
          console.error('Error getting location:', error);
          this.isLocationLoading = false;
          this.locationError = true;

          // Handle specific geolocation errors
          switch (error.code) {
            case error.PERMISSION_DENIED:
              break;
            case error.POSITION_UNAVAILABLE:
              break;
            case error.TIMEOUT:
              break;
            default:
              break;
          }

          // Keep default location if geolocation fails
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000, // 5 minutes
        },
      );
    } else {
      this.locationError = true;
    }
  }

  // Get location details from coordinates
  getLocationDetails(latitude: number, longitude: number): void {
    const payload = {
      latitude: latitude,
      longitude: longitude,
    };

    this.apiService
      .geoLocation(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          const geoLocation = res.data.data_by_pincode[0];
          this.isLocationLoading = false;
          this.userLocation = geoLocation;

          // Bind API response to address form fields
          if (this.addressForm) {
            this.addressForm.patchValue({
              locality: geoLocation.city_name || '',
              pin: geoLocation.pincode || '',
              flatHouseNo: geoLocation.full_address || '',
              state: geoLocation.state_name || '',
              city: geoLocation.city_name || '',
            });

            // Reuse existing pincode logic to auto-fill city/state
            if (geoLocation.pincode) {
              this.onPincodeChange(geoLocation.pincode);
            }
          }

          localStorage.setItem('userLocation', JSON.stringify(geoLocation));
          // this.notificationService.success('Location detected successfully');

          // Trigger change detection to immediately update the UI
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Failed to fetch location details', err);
          this.isLocationLoading = false;
          this.locationError = true;
          // this.notificationService.error(
          //   err?.error?.data?.msg || 'Failed to detect location',
          // );
          this.cdr.markForCheck();
        },
      });
  }


   async onMakeEnquiry() {
    this.paymentErrorMessage = null;

    if (!this.userData) {
      this.showPaymentError('Please login to continue with payment');
      return;
    }
    if (!this.isStorePickup && !this.userData.shipping_address) {
      this.showPaymentError('Please add a delivery address');
      return;
    }

    const canProceed = await this.ensureBuyerVerificationBeforePayment();
    if (!canProceed) {
      return;
    }

    const cartItems = localStorage.getItem('cartbooking_page_product_data');
    const cartdata = cartItems ? JSON.parse(cartItems) : [];

    const cartParts = Object.values(cartdata).map((entry: any) => ({
      part_number: entry.item.inventory_id,
      delivery_type: entry.deliveryOption, // <-- use outer deliveryOption
      req_quantity: this.parsedData?.quantity ? this.parsedData.quantity : 1,
    }));

    // Add item to cart and proceed to payment
    // const part_number = this.selectedProduct?.part_number;

    const part_number = this.selectedProduct?.part_number;

    const parts = [
      {
        part_number: part_number,
        delivery_type: this.isStorePickup ? 'Store Pickup' : 'Home Delivery',
        req_quantity: this.parsedData?.quantity ? this.parsedData.quantity : 1,
        inventory_id: this.selectedProduct?.inventory_id,
      },
    ];
    const formData = new FormData();

    formData.append('is_buy_now', 'true'); // always string
    formData.append('coupon_code', this.selectedCoupon?.coupon_code || '');
    formData.append('offer_id', this.selectedCoupon?.row_id || '');
    formData.append('parts', JSON.stringify(parts));
    formData.append('is_enquiry', 'true');
    this.loaderService.show();
    this.apiService
      .buyNow(formData)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res.success) {
            localStorage.removeItem('cartbooking_page_product_data');
            localStorage.removeItem('booking_page_product_data');
            this.orderDetail = res.data;
            localStorage.setItem(
              'createdOrderDetail',
              JSON.stringify(this.orderDetail),
            );
            this.oreder_number = this.orderDetail?.order_detail?.order_number;
            const enquiryNumber = this.orderDetail?.enquiry_numbers?.[0] || '';
            this.notificationService.success('Enquiry submitted successfully');
            this.router.navigate(['/order-confirmation'], {
              queryParams: {
                success: 'true',
                order_id: this.oreder_number,
                is_enquiry: 'true',
                enquiry_number: enquiryNumber,
              },
              state: {
                orderDetail: this.orderDetail,
                isEnquiry: true,
                enquiryNumber,
              },
            });
          } else {
            this.showPaymentError(res?.data?.msg || 'Failed to submit enquiry');
          }
          this.loaderService.hide();
          this.cdr.markForCheck();
        },
        error: (err) => {
          this.loaderService.hide();
          this.showPaymentError(
            err?.error?.data?.msg ||
              'Failed to submit enquiry. Please try again.',
          );
          this.cdr.markForCheck();
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }
}
